import { Typography } from '@one-thd/sui-atomic-components';
import { DateRangeCalendar } from '@one-thd/sui-date-pickers';
import { DateTime } from 'luxon';
import React from 'react';
export var CustomDateRange = function (_a) {
    var _b = _a.dateRangeState, startDate = _b.startDate, setStartDate = _b.setStartDate, endDate = _b.endDate, setEndDate = _b.setEndDate;
    var maxDate = DateTime.now().startOf('day').toString();
    var minDate = DateTime.now()
        .minus({ months: 25 })
        .startOf('day')
        .toString();
    return (React.createElement("div", { className: "sui-flex sui-flex-col sui-gap-4" },
        React.createElement(Typography, { variant: "body-lg" }, "Select date range for Purchase History"),
        React.createElement(DateRangeCalendar, { minDate: minDate, maxDate: maxDate, value: {
                start: (startDate === null || startDate === void 0 ? void 0 : startDate.toISODate()) || '',
                end: (endDate === null || endDate === void 0 ? void 0 : endDate.toISODate()) || '',
            }, onChange: function (_event, value) {
                setStartDate(DateTime.fromISO(value.start));
                setEndDate(DateTime.fromISO(value.end));
            } })));
};
